import React, { memo } from "react";
import styled, { keyframes } from "styled-components";

/* =========================
   Animation
========================= */

const scroll = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
`;

/* =========================
   Layout
========================= */

const Section = styled.section`
  width: 100%;
  padding: 80px 0;
  overflow: hidden;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 48px;
  font-family: "Volkhov", sans-serif;
  font-weight: 700;
  font-size: clamp(28px, 4vw, 50px);
  color: #14183e;
`;

const Marquee = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

const Track = styled.div`
  display: flex;
  width: 200%;
  animation: ${scroll} 12s linear infinite;
  will-change: transform;
`;

/* Chaque groupe = 50% EXACT */
const Group = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex: 0 0 50%;
  gap: clamp(16px, 4vw, 48px);
`;

const LogoBox = styled.div`
  width: clamp(90px, 12vw, 140px);
  height: clamp(45px, 6vw, 70px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;


/* Logo auto-responsive */
const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  opacity: 0.9;
  transition: transform 0.3s ease, opacity 0.3s ease;

  &:hover {
    transform: scale(1.08);
    opacity: 1;
  }
`;


/* =========================
   Component
========================= */

const logos = [
  { src: "/Assets/mirai.png", alt: "Mirai" },
  { src: "/Assets/colloque&associe.jpeg", alt: "Colloque & Associés" },
  { src: "/Assets/OpenMind.png", alt: "OpenMind" },
  { src: "/Assets/rndcompany.png", alt: "RND Company" },
  { src: "/Assets/syncard.png", alt: "Syncard" },
  { src: "/Assets/militodesign.png", alt: "Milito Design" },
];

const Partners = () => (
  <Section>
    <Title>Nos partenaires</Title>

    <Marquee>
      <Track>
        {/* Groupe principal */}
        <Group>
          {logos.map((logo, i) => (
            <LogoBox key={i}>
              <Logo src={logo.src} alt={logo.alt} loading="lazy" />
            </LogoBox>
          ))}
        </Group>

        <Group aria-hidden="true">
          {logos.map((logo, i) => (
            <LogoBox key={`dup-${i}`}>
              <Logo src={logo.src} alt="" />
            </LogoBox>
          ))}
        </Group>
      </Track>
    </Marquee>
  </Section>
);

export default memo(Partners);
